import { matchPath } from "react-router-dom";

import {
  PageRoute,
  Roles,
  pages as pagesConfig,
  modals as modalsConfig,
} from "src/components/routes";
import { MODALS, PAGES } from "src/types/navigation";

type Route = PageRoute;

type RouteWithScheme = Route & { scheme: PAGES };
type Routes = Record<Roles, string[]>;

export type SwitchMode = {
  mode: Roles;
};

export const prepareURL = (pathname: string) => {
  const path = pathname.split("/~")[0] as PAGES;
  const pages = Object.values(PAGES).filter((item) => item !== "*");
  //TODO fix any type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if (pages.includes(path as any)) {
    return path;
  }

  const match = pages
    .map((scheme) => matchPath(path, scheme))
    .find((item) => item);

  return match?.pathname as PAGES | undefined;
};

const allRoutes = (config: Record<string, Route>): RouteWithScheme[] =>
  Object.keys(config).map(
    (scheme: string) => ({ scheme, ...config[scheme] }) as never
  );

const filterConfig = (list: RouteWithScheme[], access: Roles): string[] =>
  list
    .filter((item) => item.access === "all" || item.access.includes(access))
    .map((item) => item.scheme);

const createRoutes = (mode: "pages" | "modals"): Routes => {
  const list = allRoutes(mode === "pages" ? pagesConfig : modalsConfig);

  return {
    guest: filterConfig(list, "guest"),
    user: filterConfig(list, "user"),
  };
};

export const allPages: PAGES[] = allRoutes(pagesConfig).map(
  (item) => item.scheme
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
) as any;
export const allowedPages: Routes = createRoutes("pages");
export const allowedModals: Routes = createRoutes("modals");

export const getRouteConfigByPath = (path?: string): Partial<PageRoute> =>
  pagesConfig[path as PAGES] || modalsConfig[path as MODALS] || {};
